import React from "react";
import TButton from "../../components/tbutton";
import AddOnsSection from "../../components/dashboard/pricing-addon";

const WeddnProSubscription = () => {
  return (
    <div className="w-full py-6 pb-8 bg-transparent">
      <div className="mx-6">
        <div className="flex items-center w-full py-10">
          <h1 className="text-[21px] font-[400] w-full text-center gap-2 flex items-center justify-center dcalligraphy">
            <h2 className="-rotate-[9deg]">Weddn</h2>{" "}
            <span className="optima py-1 px-4 bg-black text-[10px] text-white rounded-full">
              Pro
            </span>
          </h1>
        </div>
        <div className="p-2 border rounded-[7px] px-7 bg-[#F9F9F9] w-full max-h-[550px] flex flex-col justify-center items-center gap-2">
          <div className="flex flex-col items-center justify-center w-full h-full gap-[1px] pb-3">
            <h1 className="text-[20px] font-[400] glacial">Pro Bundle</h1>
            <h3 className="text-[32px] font-[400] optima blur-sm">#200,000</h3>
            <span className="text-[14px] font-[400] glacial text-gray-500 w-[200px] text-center">
              Get a combination of features for a single price
            </span>
          </div>
          <div className="flex flex-col justify-center items-center glacial text-[16px] gap-3 w-full">
            <div className="flex justify-between items-center glacial w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                MAILS
              </span>
              <span>500</span>
            </div>
            <div className="flex justify-between items-center glacial w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                LOVE WALL
              </span>
              <span>Unlimited</span>
            </div>
            <div className="flex justify-between items-center glacial w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                QR PASS
              </span>
              <span>500</span>
            </div>
            <div className="flex justify-between items-center glacial w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                WELL WISHES
              </span>
              <span>Unlimited</span>
            </div>
            <div className="flex justify-between items-center glacial w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                WEBSITE DOMAIN
              </span>
              <span>Yes</span>
            </div>
            <div className="flex justify-between items-center glacial w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                ASO EBI
              </span>
              <span>Unlimited</span>
            </div>
            <div className="flex justify-between items-center w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                COLLABORATION
              </span>
              <span>Yes</span>
            </div>
            <div className="flex justify-between items-center w-full">
              <span className="glacial font-[400] flex items-center gap-2">
                <span className="w-[2px] h-[2px] rounded-full bg-black"></span>
                PRIORITY SUPPORT
              </span>
              <span>Yes</span>
            </div>
          </div>
          <div className="py-2">
            <TButton className="bg-black uppercase text-white w-[200px]">Coming Soon</TButton>
          </div>
        </div>
      </div>
      <AddOnsSection />
    </div>
  );
};

export default WeddnProSubscription;
